import { render, staticRenderFns } from "./CruiseDetailsCrowdReviews.vue?vue&type=template&id=8d8f7912&"
import script from "./CruiseDetailsCrowdReviews.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailsCrowdReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports